import {
  AspectRatio,
  Heading,
  Img,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';

import { Link, PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { ZmyleLinks } from 'utils/paths';

export const CheckoutSection = () => {
  const { content } = usePageTextContent<StoresPageContent>();

  const {
    title,
    subtitle,
    description,
    testItLink,
    mobileCheckoutImageUrl,
    desktopCheckoutImageUrl,
  } = content.checkout;

  return (
    <PageContainer>
      <PageContent align="center" direction={['column', 'column', 'row']}>
        <Stack
          direction={['column', 'column', 'row', 'row']}
          align="center"
          justify="space-between"
          spacing="2.25rem"
          w="full"
        >
          <VStack align="flex-start" spacing="5rem">
            <VStack align="flex-start" spacing="1rem">
              <Heading fontSize="1.25rem" color="store.primary">
                {title}
              </Heading>

              <Heading fontSize="1.5rem">{subtitle}</Heading>

              <Text maxW={['full', 'full', '21.5rem']}>{description}</Text>

              <Link
                href={ZmyleLinks.MAGIC_CHECKOUT}
                target="_blank"
                color="store.primary"
                _hover={{ color: 'store.primary' }}
                isExternal
              >
                {testItLink}
              </Link>
            </VStack>
          </VStack>

          <Stack
            w="full"
            align="center"
            spacing="2.25rem"
            direction={['column', 'column', 'row']}
          >
            <AspectRatio
              ratio={25 / 54}
              w={['full', 'full', '32.5%', 'full']}
              maxW="15rem"
            >
              <Img
                src={mobileCheckoutImageUrl}
                rounded="lg"
                shadow="xl"
                alt="Mobile Checkout"
                loading="lazy"
              />
            </AspectRatio>

            <AspectRatio
              ratio={128 / 89}
              w={['full', 'full', '67.5%', 'full']}
              maxW="46.5rem"
            >
              <Img
                src={desktopCheckoutImageUrl}
                rounded="lg"
                shadow="xl"
                alt="Desktop Checkout"
                loading="lazy"
              />
            </AspectRatio>
          </Stack>
        </Stack>
      </PageContent>
    </PageContainer>
  );
};
